module.exports = __webpack_public_path__ + "static/img/banner_fan.34f6e13.png";